

export class TimeModel {

  days: number | undefined = undefined;

  hours: number | undefined = undefined;

  minutes: number | undefined = undefined;

  seconds: number | undefined = undefined;

}
